export function respToJson(resp) {
  if (!resp.ok) {
    throw Error(resp.statusText);
  }
  return resp.json();
}

export function fetchJSON(url, options, data) {
    const opts = Object.assign({
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; odata=nometadata',
        },
        body: JSON.stringify(data),
    }, options);

    return fetch(url, opts);
}

export function dispatchJSON(dispatch, promise, success, error) {
    promise
    .then(respToJson)
    .then((json) => {
        return dispatch({
            type: success,
            payload: json,
        });
    })
    .catch((err) => {
        return dispatch({
            type: error,
            payload: {error: err.message},
        });
    });
}



// WEBPACK FOOTER //
// ./src/utils/fetching.js